/**
 * The wordmark's spelling: **WillnQ**, with the trailing Q capitalised.
 *
 * <p>This is the BRAND as it is written when a person reads it: the wordmark in `BrandMark`, the
 * brand-first document title on the site root, and the organization's name in structured data, which
 * is the name Google may display in a search result or knowledge panel.</p>
 *
 * <p>`env.appName` (`VITE_APP_NAME`) now carries the SAME spelling — it was normalised from `Willnq`
 * to `WillnQ`, so the ` | WillnQ` title suffix and `og:site_name` agree with the wordmark. The two
 * remain separate on purpose and must not be collapsed: `VITE_APP_NAME` is per-deployment
 * configuration validated at startup, and this is a compile-time constant the code can rely on being
 * present and correctly spelled. Nothing here should be re-derived from the environment.</p>
 *
 * <p>It lives here rather than as a literal inside `BrandMark` so the two places that render the brand
 * to a human — the wordmark and the head — cannot drift apart.</p>
 */
export const BRAND_NAME = 'WillnQ';
